import { api } from 'app/core/services/base/api.service'
import { CommonResponse } from 'app/core/services/base/response.service'
import {
    Com0102CtlrIn,
    Com0102CtlEvtOut,
    Com0102CtlMnuOut,
    Com0102CtlBnnOut,
    Com0102CtlTermOut,
    Com0102CtlNotiOut,
    Com0102CtlRecomPrdOut,
    Com0102CtlUrlOut,
    Com0102CtlBrncOut,
    Com0102CtlBrcdBnnOut,
} from 'app/core/models/api/com/com0102'
import { Com0104CtlrOut } from 'app/core/models/api/com/com0104'
import { Com0202CtlrIn, Com0202CtlrOut } from 'app/core/models/api/com/com0202'
import { Com0203CtlrIn, Com0203CtlrOut } from 'app/core/models/api/com/com0203'
import { Com0204CtlrOut } from 'app/core/models/api/com/com0204'
import { Com0206CtlrOut } from 'app/core/models/api/com/com0206'
import { Com0207CtlrIn, Com0207CtlrOut } from 'app/core/models/api/com/com0207'
import { Com0302CtlrOut } from 'app/core/models/api/com/com0302'
import { Com0304CtlrIn, Com0304CtlrOut } from 'app/core/models/api/com/com0304'
import { Com0306CtlrIn, Com0306CtlrOut } from 'app/core/models/api/com/com0306'
import { Com0402CtlrIn, Com0402CtlrOut } from 'app/core/models/api/com/com0402'
import { Com0406CtlrIn, Com0406CtlrOut } from 'app/core/models/api/com/com0406'
import { Com0403CtlrOut, Com0403CtlrIn } from 'app/core/models/api/com/com0403'
import { Com0208CtlrOut } from 'app/core/models/api/com/com0208'

export type { Com0203CtlrIn, Com0203CtlrOut }

let suffixPath = ''
/**
 * 공통 서비스
 */
const postApi = api.injectEndpoints({
    endpoints: (build) => ({
        //전자금융 선조회
        selectCom0406: build.query<Com0406CtlrOut, Com0406CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com04/com0406`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0406CtlrOut>,
        }),
        //"권유직원 조회
        selectCom0402: build.query<Com0402CtlrOut, Com0402CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com04/com0402`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0402CtlrOut>,
        }),
        //부점정보조회
        selectCom0403: build.query<Com0403CtlrOut, Com0403CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com04/com0403`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0403CtlrOut>,
        }),
        // PDF 파일 경로 암호화
        selectCom0202: build.query<Com0202CtlrOut, Com0202CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com02/com0202`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0202CtlrOut>,
        }),
        // 보안 키패드 두 값 비교
        selectCom0203: build.query<Com0203CtlrOut, Com0203CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com02/com0203`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0203CtlrOut>,
        }),
        // 페이지 유효성체크
        selectCom0204: build.query<Com0204CtlrOut, void>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com02/com0204`,
                method: 'POST',
                body,
            }),
            extraOptions: {
                skipProgress: true,
                handleLocally: true,
            },
            transformResponse: CommonResponse<Com0204CtlrOut>,
        }),
        // 안랩 V3 제품번호를 암호화해서 전달
        selectCom0206: build.query<Com0206CtlrOut, void>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com02/com0206`,
                method: 'POST',
                body,
            }),
            extraOptions: {
                skipProgress: true,
            },
            transformResponse: CommonResponse<Com0206CtlrOut>,
        }),

        // 제휴처코드 유효성체크
        selectCom0207: build.query<Com0207CtlrOut, Com0207CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com02/com0207`,
                method: 'POST',
                body,
            }),
            extraOptions: { handleLocally: true },
            transformResponse: CommonResponse<Com0207CtlrOut>,
        }),

        // 세션 초기화
        selectCom0208: build.query<Com0208CtlrOut, void>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com02/com0208`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0208CtlrOut>,
        }),

        // 고객 (주소) 정보 조회
        selectCom0302: build.query<Com0302CtlrOut, void>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com03/com0302`,
                method: 'POST',
                body: {},
            }),
            transformResponse: CommonResponse<Com0302CtlrOut>,
        }),
        // 은행 증권 조회
        selectCom0304: build.query<Com0304CtlrOut, void>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com03/com0304`,
                method: 'POST',
                body: {},
            }),
            transformResponse: CommonResponse<Com0304CtlrOut>,
        }),
        // 주택청약가입자등록시 시군구조회
        selectCom0306: build.query<Com0306CtlrOut, Com0306CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com03/com0306`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0306CtlrOut>,
        }),

        // 공통코드 i-one URL link 'EXTL_LURL'
        selectComUrl0102: build.query<Com0102CtlUrlOut, Com0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com01/com0102`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0102CtlUrlOut>,
        }),

        // 관리자등록캐시조회   UIBMAO_001   공지 알림
        selectComNoti0102: build.query<Com0102CtlNotiOut, Com0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com01/com0102`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0102CtlNotiOut>,
        }),

        // 관리자등록캐시조회   UIBMAO_003   베너 - man.service에 있음
        selectBannerCom0102: build.query<Com0102CtlBnnOut, void>({
            query: () => ({
                url: `${suffixPath}/prd/com/com01/com0102`,
                method: 'POST',
                body: { dsrnTgtBacd: '003', cdgpId: '', ccddId: '' },
            }),
            transformResponse: CommonResponse<Com0102CtlBnnOut>,
        }),

        // 관리자등록캐시조회   UIBMAO_004   이벤트
        selectCom0102: build.query<Com0102CtlEvtOut, Com0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com01/com0102`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0102CtlEvtOut>,
        }),

        // 관리자등록캐시조회   UIBMAO_005   영업점 공지사항
        selectComBrnc0102: build.query<Com0102CtlBrncOut, Com0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com01/com0102`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0102CtlBrncOut>,
        }),

        // 관리자등록캐시조회   UIBMAO_006   영업점 베너
        selectComBrbn0102: build.query<Com0102CtlBrcdBnnOut, Com0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com01/com0102`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0102CtlBrcdBnnOut>,
        }),

        // 관리자등록캐시조회   UIBMAO_008   추천상품목록
        selectComRecomPrd0102: build.query<
            Com0102CtlRecomPrdOut,
            Com0102CtlrIn
        >({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com01/com0102`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0102CtlRecomPrdOut>,
        }),

        // 관리자등록캐시조회   UIBMAO_110  약관
        selectTermCom0102: build.query<Com0102CtlTermOut, void>({
            query: () => ({
                url: `${suffixPath}/prd/com/com01/com0102`,
                method: 'POST',
                body: {
                    dsrnTgtBacd: '110',
                    cdgpId: 'WTCNS_URL_ADR',
                    ccddId: '',
                },
            }),
            transformResponse: CommonResponse<Com0102CtlTermOut>,
        }),
        // 관리자등록캐시조회   UIBMAO_112   사용자메뉴
        selectMnu0102: build.query<Com0102CtlMnuOut, void>({
            query: () => ({
                url: `${suffixPath}/prd/com/com01/com0102`,
                method: 'POST',
                body: { dsrnTgtBacd: '112', cdgpId: '', ccddId: '' },
            }),
            extraOptions: { handleLocally: true, skipProgress: true },
            transformResponse: CommonResponse<Com0102CtlMnuOut>,
        }),
        // 지난이벤트 목록 조회
        selectCom0104: build.query<Com0104CtlrOut, ''>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com01/com0104`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0104CtlrOut>,
        }),
        // 관리자등록캐시조회   UIBMAO_004   이벤트
        selectCacheInfo: build.query<Com0102CtlEvtOut, Com0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/prd/com/com01/com0102`,
                method: 'POST',
                body,
            }),
            extraOptions: { skipProgress: true },
            transformResponse: CommonResponse<Com0102CtlEvtOut>,
        }),
    }),
})

export const {
    useLazySelectCom0102Query,
    useLazySelectMnu0102Query,
    useLazySelectComUrl0102Query,
    useLazySelectComNoti0102Query,
    useLazySelectBannerCom0102Query,
    useLazySelectTermCom0102Query,
    useLazySelectComRecomPrd0102Query,
    useLazySelectComBrnc0102Query,
    useLazySelectComBrbn0102Query,
    useLazySelectCom0104Query,
    useLazySelectCom0202Query,
    useLazySelectCom0203Query,
    useLazySelectCom0204Query,
    useLazySelectCom0206Query,
    useLazySelectCom0207Query,
    useLazySelectCom0208Query,
    useLazySelectCom0302Query,
    useLazySelectCom0304Query,
    useLazySelectCom0306Query,
    useLazySelectCom0402Query,
    useLazySelectCom0403Query,
    useLazySelectCom0406Query,
    useLazySelectCacheInfoQuery,
} = postApi

export const {
    endpoints: {
        selectCom0102,
        selectMnu0102,
        selectComUrl0102,
        selectComNoti0102,
        selectBannerCom0102,
        selectTermCom0102,
        selectComRecomPrd0102,
        selectComBrnc0102,
        selectComBrbn0102,
        selectCom0104,
        selectCom0202,
        selectCom0203,
        selectCom0204,
        selectCom0206,
        selectCom0207,
        selectCom0208,
        selectCom0302,
        selectCom0304,
        selectCom0306,
        selectCom0402,
        selectCom0403,
        selectCom0406,
    },
} = postApi
